<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <form @submit.prevent="onSubmit">
      <v-alert
        v-model="alertErroDataAtualizacao"
        dismissible
        close-icon="mdi-delete"
        colored-border
        border="left"
        color="red"
        elevation="2"
        type="error"
      >
      <p v-html="mensagemCompletaErroCalculo"></p>
      </v-alert>
      <v-row>
        <v-col>
          <v-text-field v-model="descricao" label="Descrição"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <DatePicker
            :nome="dataValorOriginalLabel"
            tipo="dataValorOriginal"
            regras="data|required"
          />
        </v-col>

        <v-col>
          <ValidationProvider
            v-slot="{ errors }"
            name="valorOriginal"
            rules="required|monetario|naoZero"
          >
            <v-currency-field
              v-model="valorOriginal"
              :label="valorOriginalLabel"
              :prefix="moedaVigente"
              :error-messages="errors"
            ></v-currency-field>
          </ValidationProvider>
        </v-col>
      </v-row>
      <v-row v-if="tipo !== 'encargosMoratorios'">
        <v-col class="pb-0">
          <v-checkbox
            class="checkbox-text"
            v-model="habilitarDataJuros"
            label="Há incidência de juros?"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row v-if="tipo == 'encargosMoratorios'">
        <v-col class="pt-0" cols="6">
          <DatePicker
            nome="Data para atualização do valor *"
            tipo="dataAtualizacao"
            regras="data|required"
          />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col class="pt-0">
          <slot name="jurosDatePicker" :habilitarDataJuros="habilitarDataJuros">
            <DatePicker
              nome="Data de início da incidência dos juros "
              regras="data"
              tipo="dataJuros"
              dica="Juros e/ou multa (essa a partir de 2020) incidentes em casos de dolo e mora."
            />
          </slot>
        </v-col>
        <v-col class="pt-0">
          <DatePicker
            nome="Data para atualização do valor *"
            tipo="dataAtualizacao"
            regras="data|required"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p id="formFooter">* Campo Obrigatório</p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="auto">
          <v-tooltip bottom :disabled="!invalid">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-btn
                  class="ma-2"
                  type="submit"
                  :disabled="invalid"
                  outlined
                  color="#2f598b"
                >Calcular</v-btn>
              </span>
            </template>
            <span>
              Botão será ativado assim que todos os campos obrigatórios forem
              preenchidos corretamente.
            </span>
          </v-tooltip>
          <v-btn
            v-if="existemCalculos"
            class="ma-2"
            outlined
            color="#2f598b"
            @click="limparLista"
          >Limpar lista</v-btn>
        </v-col>
      </v-row>
    </form>
  </ValidationObserver>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  setInteractionMode
} from "vee-validate";
setInteractionMode("eager");
import DatePicker from "@/components/DatePicker.vue";
import axios from "axios";
import { mapActions } from "vuex";

export default {
  name: "FormCalculo",
  props: {
    tipo: {
      type: String
    }
  },
  data: function() {
    return {
      descricao: "",
      valorOriginal: 0,
      moedaVigente: "R$",
      dataAtualizacaoMaxima: "",
      mensagemErroDataAtualizacaoMaxima: "",
      alertErroDataAtualizacao: false,
      habilitarDataJuros: false
    };
  },
  computed: {
    existemCalculos() {
      return this.$store.state.calculos.length > 0 ? true : false;
    },
    urlCalculo() {
      if (this.tipo == "3013") {
        return "/calcular3013";
      } else if (this.tipo == "encargosMoratorios") {
        return "/calcularEncargosMoratorios";
      }
      return "/calcular";
    },
    mensagemCompletaErroCalculo() {
      return this.mensagemErroDataAtualizacaoMaxima + this.dataAtualizacaoMaxima;
    },
    dataValorOriginalLabel() {
      return this.tipo === 'encargosMoratorios' ? 'Vencimento do Prazo Fixado *' : 'Data do Valor Original *';
    },
    valorOriginalLabel() {
      return this.tipo === 'encargosMoratorios' ? 'Valor Imputado *' : 'Valor Original *';
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    DatePicker
  },
  methods: {
    ...mapActions(["addCalculo", "clearCalculos"]),
    onSubmit() {
      this.$refs.observer.validate();
      let formData = {
        descricao: this.descricao,
        dataValorOriginal: this.$store.state.dataValorOriginal,
        valorOriginal: this.valorOriginal,
        dataAtualizacao: this.$store.state.dataAtualizacao
      };
      if (this.$store.state.dataJuros && this.habilitarDataJuros) {
        formData["dataJuros"] = this.$store.state.dataJuros;
      }

      axios
        .post(this.urlCalculo, formData)
        .then(resposta => {
          this.addCalculo(resposta.data.resultado);
          this.alertErroDataAtualizacao = false;
        })
        .catch(error => {
          if (
            error.response.status == 406 &&
            error.response.data.sucesso == false
          ) {
            this.dataAtualizacaoMaxima =
              error.response.data.erro.dataMaximaCalculo;
            this.mensagemErroDataAtualizacaoMaxima =
              error.response.data.erro.mensagem;
            this.alertErroDataAtualizacao = true;
          }
          console.log(error.response.data.erro.dataMaximaCalculo);
        });
    },
    limparLista() {
      this.clearCalculos();
    }
  },
  watch: {
    "$store.state.dataValorOriginal"(novaData) {
      let novaDataFormatada =
        novaData.substr(8, 2) +
        "/" +
        novaData.substr(5, 2) +
        "/" +
        novaData.substr(0, 4);
      axios
        .get("/moeda", {
          params: {
            data: novaDataFormatada
          }
        })
        .then(resposta => (this.moedaVigente = resposta.data.moeda))
        .catch(error => console.log(error));
    }
  }
};
</script>
<style lang="scss" scoped>
#formFooter {
  font-size: 12px;
}

.custom-checkbox-column {
  display: flex;
  align-items: flex-end; /* Aligns content to the bottom */
  padding-bottom: 0 !important; /* Removes bottom padding */
}
</style>
